document.addEventListener("DOMContentLoaded", () => {
    var variants = productVariants;
  
    function updateOOScolours() {
      const selectedSizeInput = document.querySelector(
        'input[data-option-name="Size"]:checked'
      );
      const selectedSize = selectedSizeInput ? selectedSizeInput.value : null;
      var colourSelectors = document.querySelectorAll(
        'input[data-option-name="Colour"]'
      );
  
      if (selectedSize) {
        colourSelectors.forEach((colour) => {
          const colourValue = colour.value;
  
          const matchingVariant = variants.find(
            (variant) =>
              variant.option1 === colourValue && variant.option2 === selectedSize
          );
          if (matchingVariant) {
              if (matchingVariant.available) {
                colour.classList.remove('swatch_disabled');
              } else {
                colour.classList.add('swatch_disabled');
              }
            } else {
              colour.classList.add('swatch_disabled');
            }

        });
      }
    }
  
    function delayUpdateOOS() {
      setTimeout(updateOOScolours, 4000);
    }
  
    function attachListeners() {
      const inputs = document.querySelectorAll(
        'input[data-option-name="Size"], input[data-option-name="Colour"]'
      );
      inputs.forEach((input) => {
        input.addEventListener("change", delayUpdateOOS);
      });
    }
  
    attachListeners();
  
    const observer = new MutationObserver(() => {
      attachListeners();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    delayUpdateOOS();
  });
  